import { Outlet } from '@tanstack/react-router'
import { createRootRoute } from '@tanstack/react-router'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: 'var(--bg-gray-light)' }}>
      <div
        className="flex-1 flex flex-col transition-all duration-300 min-w-0"
      >

        <main
          className="flex-1 overflow-y-auto scrollbar-hide"
          style={{backgroundColor: 'var(--bg-gray-light)' }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}
